export const API_BASE_URL = import.meta.env.VITE_PUBLIC_API_URL;
